export enum DocFormat {
  Csv = "csv",
  Pdf = "pdf",
  Doc = "doc"
}

export const DOC_FORMAT_MIME_TYPE: Record<DocFormat, string> = {
  [DocFormat.Csv]: "text/csv",
  [DocFormat.Pdf]: "application/pdf",
  [DocFormat.Doc]: "application/msword"
};
